module.exports = __webpack_public_path__ + "ea7145763e46b1f73f9251576125d92f.svg";